
import { Component, Vue } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Util from "@/lib/util";
import LanguageList from "@/components/language-list.vue";
import ChangePassword from "@/views/setting/user/change-password.vue";
import breadcrumbNav from "@/components/breadcrumb-nav.vue";
import AppConsts from "@/lib/appConst";

@Component({
  components: { LanguageList, ChangePassword, breadcrumbNav },
  props: {
    hideBreadcrumb: Boolean,
  },
})
export default class Tiptop extends AbpBase {
  changePasswordModalShow: Boolean = false;
  keyword: string = "";

  get tenant() {
    return Util.abp.multiTenancy.getTenantCookie();
  }

  get isStandardEdition() {
    return Util.isStandardEdition();
  }

  get user() {
    var user = {
      name: "",
      surname: "",
      userName: "",
    };
    return this.$store.state.session.user
      ? this.$store.state.session.user
      : user;
  }
  get avatar() {
    let avatar = Util.abp.session.getUserAvatarCookie();
    if (!avatar) {
      return AppConsts.user.avatar;
    }
    return Util.abp.session.getUserAvatarCookie();
  }
  get currentPath() {
    return this.$store.state.app.currentPath;
  }

  get isAuthorized() {
    return !!this.$store.state.session.user;
  }

  created() {
    if (this.$route.query.q) {
      this.keyword = this.$route.query.q.toString();
    }
  }

  handleClickAddToBookmark() {
    let url = window.location || "http://www.feedeem.com";
    let title = document.title;
    let ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("360se") > -1) {
      alert("由于360浏览器功能限制，请按 Ctrl+D 手动收藏！");
    }
    // else if (ua.indexOf("msie 8") > -1) {
    //   window.external.AddToFavoritesBar(url, title); //IE8
    // }
    // else if (document.all) {
    //   try {
    //     window.external.addFavorite(url, title);
    //   } catch (e) {
    //     alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!');
    //   }
    // }
    // else if (window.sidebar) {
    //   window.sidebar.addPanel(title, url, "");
    // }
    else {
      alert("您的浏览器不支持,请按 Ctrl+D 手动收藏!");
    }
  }

  handleKeywordKeyDown(e) {
    if (e.charCode === 13) {
      this.handleClickSearch();
    }
  }

  handleClickSearch() {
    if (!this.keyword) {
      // this.$Message.warning(this.L('PleaseInputKeywords'));
      // return;
      this.$router.push("/search");
    }
    this.$router.push("/search?q=" + this.keyword);
  }

  handleClickSearchByImage() {
    this.$router.push("/search-by-image");
  }

  handleClickHeaderNavItem(routeName: string) {
    this.$router.push({
      name: routeName,
    });
  }

  handleClickUserDropdown(name: string) {
    if (name === "ownSpace") {
      return;
      Util.openNewPage(this, "ownspace_index", null, null);
      this.$router.push({
        name: "ownspace_index",
      });
    } else if (name === "changePassword") {
      this.changePasswordModalShow = true;
    } else if (name === "loginout") {
      this.$store.commit("app/logout", this);
      Util.abp.auth.clearToken();
      location.reload();
    }
  }
}
